import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { emitPageLoad } from '../../utils/gtm/events';

const getCookieValue = (name: string): any | undefined => {
  const env = process.env.REACT_APP_STAGE || 'prod';
  const tripsCookieMatch = document.cookie.match(new RegExp(`(^| )${name}_trips_${env}=([^;]+)`));
  if (tripsCookieMatch) {
    try {
      return JSON.parse(decodeURIComponent(tripsCookieMatch[2]));
    } catch (error) {
      return decodeURIComponent(tripsCookieMatch[2]);
    }
  }

  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) {
    try {
      return JSON.parse(decodeURIComponent(match[2]));
    } catch (error) {
      return decodeURIComponent(match[2]);
    }
  }
  return undefined;
};

const getDeviceId = (): string | null => {
  const deviceCookieMatch = document.cookie.match(/(^|;) ?device=([^;]*)(;|$)/);
  if (deviceCookieMatch) {
    return deviceCookieMatch[2];
  }

  return null;
};

const getUserType = (): string | null => {
  const userSessionGenericCookie = getCookieValue('user_session');
  const userSessionTripsCookie = getCookieValue(`user_session_trips_${process.env.REACT_APP_STAGE}`);

  const userSessionCookie = userSessionTripsCookie?.personType === 'traveler' ? userSessionTripsCookie : userSessionGenericCookie;
  if (userSessionCookie?.personType) {
    return userSessionCookie.personType;
  }

  return null;
};

const PageLoadTracker = () => {
  const location = useLocation();
  const { isAuthenticated, loggedInTraveler } = useAuthStore();
  const previousLocationRef = useRef<string>('');

  useEffect(() => {
    if (isAuthenticated === null) {
      return;
    }

    if (previousLocationRef.current !== location.pathname + location.search) {
      previousLocationRef.current = location.pathname + location.search;

      const pageUrl = window.location.href;
      const pagePath = location.pathname;
      const pageTitle = document.title || '';
      const pageReferrer = document.referrer || '';

      const userStatus = isAuthenticated ? 'logged in' : 'logged out';
      const travelerId = loggedInTraveler?.id || null;
      const deviceId = getDeviceId();
      const userType = getUserType();

      emitPageLoad({
        user_status: userStatus,
        traveler_id: travelerId,
        device_id: deviceId,
        user_type: userType,
        page_url: pageUrl,
        page_path: pagePath,
        page_title: pageTitle,
        page_referrer: pageReferrer,
        site: 'Trips Site',
      });
    }
  }, [location, isAuthenticated, loggedInTraveler]);

  return null;
};

export default PageLoadTracker;
